/**
 * Mobile menu panel stack.
 *
 * L2 panels are rendered by their own mega-menu section and MOVED here with
 * appendChild, never innerHTML, so no id is duplicated.
 *
 * A row is expandable only when a matching data-mobile-panel exists: data-megamenu is
 * emitted on every link block, so its presence proves nothing.
 */
const MOBILE_BREAKPOINT = 990;

export default function () {
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  if (window.innerWidth >= MOBILE_BREAKPOINT) return;

  const root = menu.querySelector('[data-mobile-panel="root"]');
  if (!root) return;

  const panels = document.querySelectorAll('[data-mobile-panel]:not([data-mobile-panel="root"])');
  if (!panels.length) return;

  const openPanel = (panel) => {
    panel.hidden = false;
    // Next frame, so the panel is laid out before the transition starts.
    requestAnimationFrame(() => {
      panel.classList.add('is-active');
      menu.classList.add('is-nested');
    });
  };

  const closePanels = (animate) => {
    menu.classList.remove('is-nested');
    menu.querySelectorAll('[data-mobile-panel].is-active').forEach((panel) => {
      if (panel === root) return;
      panel.classList.remove('is-active');
      if (animate) {
        window.setTimeout(() => {
          panel.hidden = true;
        }, 300);
      } else {
        panel.hidden = true;
      }
    });
  };

  panels.forEach((panel) => {
    const id = panel.getAttribute('data-mobile-panel');
    const row = root.querySelector('[data-megamenu="' + id + '"]');
    if (!row) return;

    menu.appendChild(panel);

    const link = row.querySelector('a');
    if (!link) return;

    row.classList.add('has-panel');
    // Label follows the row's text: the panel's section cannot see the block title.
    const label = panel.querySelector('[data-mobile-menu-back-label]');
    if (label) label.textContent = link.textContent.trim();

    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      link.setAttribute('aria-expanded', 'true');
      openPanel(panel);
    });

    const back = panel.querySelector('[data-mobile-menu-back]');
    if (back) {
      back.addEventListener('click', () => {
        link.setAttribute('aria-expanded', 'false');
        closePanels(true);
      });
    }
  });

  // Always reopen at the root. Reset on every toggle rather than reading
  // is-menu-open, whose value here depends on handler registration order.
  document.querySelectorAll('[data-open-menu]').forEach((toggle) => {
    toggle.addEventListener('click', () => closePanels(false));
  });
}
